module.exports = {
      id: "paperclip-usage",
      viewBox: "0 0 19 19",
      url: "img/" + "sprite.svg#paperclip-usage",
      toString: function () {
        return this.url;
      }
    }